import { 
	ifAuthenticated, 
	ifNotAuthenticated, 
	ifAuthenticatedOnline, 
	AppTabs,
	Edit,
	Show,
	Create,
	Crud,
	trans
} from '@/router/index'

import Callqueue from '@/components/modules/callcenter/Callqueue'
import CallqueuesSettings from '@/components/modules/callcenter/settings/CallqueuesSettings'


export const callcenter = [
	{ 
		path: '/callcenter',
		beforeEnter: ifAuthenticatedOnline,
		component: AppTabs, 
		props: {
			tabs: [
				{
					to: '/callcenter/',
					text: 'Campagne',
				},
			],
		},
		children: [
			{
				path: '/callcenter/',
				beforeEnter: ifAuthenticatedOnline,
				component: Crud,
				meta: {
					title: trans('callqueue')
				},
				props: {
					modelDef: 'callqueues',
					actionIcon: 'mdi-phone-log',
					title: 'Campagne'
				}
			},
		],
	},
	{ 
		path: '/callcenter/callqueues/create',
		name: 'callqueues-create',
		beforeEnter: ifAuthenticatedOnline,
		component: Create,
		props: (route) => ({
			modelDef: 'callqueues',
			redirect: route.params.redirect
		}),
	},
	{ 
		path: '/callcenter/callqueues/:id/edit',
		name: 'callqueues-edit',
		beforeEnter: ifAuthenticatedOnline,
		component: Edit,
		props: (route) => ({
			modelDef:  'callqueues',
			id:  parseInt(route.params.id)
		}),
	},
	{
		path: '/callcenter/callqueues/:id',
		beforeEnter: ifAuthenticatedOnline,
		component: AppTabs,
		props: (route) => ({
			tabs: [
				{
					to: '/callcenter/callqueues/' + route.params.id,
					text: 'Campagne',
				},
				{
					to: '/callcenter/callqueues/' + route.params.id + '/outcomes',
					text: 'Storico Esiti',
				},
			],
		}),
		children: [
			{
				path: '/callcenter/callqueues/:id',
				name: 'callqueues-show',
				beforeEnter: ifAuthenticatedOnline,
				component: Callqueue,
				meta: {
					title: 'Campagne'
				},
				props: (route) => ({
					id: parseInt(route.params.id)
				}),
			},
			{
				path: '/callcenter/callqueues/:id/outcomes',
				name: 'callqueues-outcomes',
				beforeEnter: ifAuthenticatedOnline,
				component: Crud,
				meta: {
					title: 'Storico Esiti'
				},
				props: (route) => ({
					modelDef: 'business-callqueueoutcomes',
					title: 'Storico Esiti',
					subFilters: { callqueue_id: parseInt(route.params.id) },
					crudDialog: true,
				}),
			},
		]
	},
	{ 
		path: '/settingscallcenter/',
		name: 'settingscallcenter',
		beforeEnter: ifAuthenticatedOnline,
		component: AppTabs,
		props: {
			tabs: [
				{
					to: '/settingscallcenter',
					text: 'Campagne',
				},
			],
		},
		children: [
			{
				path: '/settingscallcenter/',
				beforeEnter: ifAuthenticatedOnline,
				component: CallqueuesSettings,
			},	
		],
	},
]